export default __webpack_public_path__ + "static/media/delete.52fe89b7.svg";